/** WEBPAGE: fila/columna 1-based como en Sheets (fila 140 = índice 139 en array). */

export function cellAt(values, row, col) {
  const r = values[row - 1];
  if (!r || r[col - 1] == null) return '';
  return String(r[col - 1]).trim();
}

/** C140: correo, mailto:… o URL absoluta. */
export function contactHrefFromCell(c140) {
  const raw = String(c140 || '').trim();
  if (!raw) return 'mailto:comercial@yodesarrollo.mx';
  const lower = raw.toLowerCase();
  if (lower.startsWith('mailto:')) return raw;
  if (lower.startsWith('http://') || lower.startsWith('https://')) return raw;
  if (raw.includes('@')) return `mailto:${raw}`;
  return `mailto:${raw}`;
}

/** B154: solo dígitos para wa.me */
export function whatsappHrefFromPhone(b154) {
  const raw = String(b154 || '').trim();
  if (!raw) return 'https://api.whatsapp.com/send?phone=5216623184512';
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '#';
  return `https://wa.me/${digits}`;
}
